module.exports = __webpack_public_path__ + "img/helicopter.5ab6b41b.svg";